import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API.js";

import loadingBricksGif from "UI/images/loading_bricks_blue.gif";

import { useDebounce } from "Utilities/Hooks/useDebounce";

MemberSearch.propTypes = {
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func,
  setSearchResultData: PropTypes.func,
  signupItemID: PropTypes.number,
  triggerInputFocus: PropTypes.bool,
};

export default function MemberSearch({
  searchTerm,
  setSearchTerm,
  setSearchResultData,
  signupItemID,
  triggerInputFocus,
}) {
  const inputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  useEffect(() => {
    // Autofocus doesn't work on this input because of how the popover handles things,
    // so use `triggerInputFocus` to manually set focus when popover opens
    inputRef.current.focus();
  }, [triggerInputFocus]);

  useEffect(() => {
    const searchReq = API.searchForMember({
      searchTerm: debouncedSearchTerm,
      signupItemID,
    });

    if (debouncedSearchTerm?.length <= 2) {
      setSearchResultData(null);
    }

    if (debouncedSearchTerm?.length > 2) {
      setIsLoading(true);

      searchReq
        .post()
        .then((data) => {
          setSearchResultData(data);
          setIsLoading(false);
        })
        .catch((err) => {
          setSearchResultData({ error: true });
          setIsLoading(false);
        });
    }

    return () => searchReq.cancel();
  }, [debouncedSearchTerm, setSearchResultData, signupItemID]);

  return (
    <Wrapper>
      <Input
        ref={inputRef}
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <LoadingIndicator isLoading={isLoading}>
        <LoadingGif src={loadingBricksGif} alt="loading" />
      </LoadingIndicator>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
`;

const Input = styled.input`
  border: none;
  border-radius: 8px;
  background: #fff;
  outline: none;
  display: block;
  width: 100%;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  padding: 2px 8px;
  padding-right: 36px;
`;

const LoadingIndicator = styled.div`
  position: absolute;
  top: 7px;
  right: 4px;
  opacity: ${(props) => (props.isLoading ? 1 : 0)};
  transition: opacity 250ms;
`;

const LoadingGif = styled.img`
  height: 24px;
  width: 24px;
`;
